import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
Typography,
} from "@mui/material";
import { BaseModal } from "../../../components/Modal/BaseModal";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { RootState } from "../../../store";
import { useEffect, useState } from "react";
import { getRateTypes } from "../../../slices/productcostseeds.slice";
import { saveRateTypeMapping } from "../../../slices/serviceagreements.slice";
import { toast } from "react-toastify";

interface Props {
  open: boolean;
  handleClose: () => void;
  editItem: any;
}

export const MapRateTypeModal = ({ open, handleClose, editItem }: Props) => {
  const dispatch = useAppDispatch();
  const { rateTypesArray } = useAppSelector(
    (state: RootState) => state.seedsdropdown
  );

  const [selectedRateType, setSelectedRateType] = useState("");

  useEffect(() => {
    dispatch(getRateTypes());
  }, []);

  useEffect(() => {
    if (editItem) {
      setSelectedRateType(editItem.rateTypeId);
    }
  }, [editItem]);

  // useEffect(() => {
  //   const prod = productNames.find((pr) => pr.id === product.productId);
  //   if (prod) {
  //     setSelectedProductId(prod.id);
  //   }
  //   setNotes(product?.notes ?? "");
  // }, [product, productNames]);

  const handleProductChange = (event: any) => {
    setSelectedRateType(event.target.value);
  };

  const handleSave = () => {
    dispatch(
      saveRateTypeMapping({
        id: editItem.id,
        rateTypeId: selectedRateType
      })
    ).then(() => {
      toast.success("Landlord Rate type mapping saved successfully!");
      handleClose();
    });
  };

  return (
    <BaseModal open={open} handleClose={handleClose}>
      <Box display={"flex"} flexDirection={"column"} gap={5}>
        <Typography variant="h6"> Product Mapping </Typography>
        <Box display={"flex"} flexDirection={"column"} gap={2}>
           <TextField
            label="Year"
            variant="outlined"
            value={editItem?.year || ""}
            InputProps={{
              readOnly: true,
            }}
          />
          <TextField
            label="Landlord"
            variant="outlined"
            value={editItem?.landLordName || ""}
            InputProps={{
              readOnly: true,
            }}
          />
          <FormControl>
            <InputLabel>Rate Type</InputLabel>
            <Select
              value={selectedRateType}
              label="Rate Type"
              onChange={handleProductChange}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 200,
                    overflow: "auto",
                  },
                },
              }}
            >
              {rateTypesArray.map((rateType) => (
                <MenuItem key={rateType.id} value={rateType.id}>
                  {rateType.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Box display={"flex"} justifyContent={"flex-end"} gap={2}>
          <Button
            variant="contained"
            color="primary"
            disabled={!selectedRateType}
            onClick={handleSave}
          >
            Save
          </Button>
          <Button variant="outlined" color="error" onClick={handleClose}>
            Cancel
          </Button>
        </Box>
      </Box>
    </BaseModal>
  );
};
